/**
 * @name isBase64
 * @description Checks if the input is a base64 image.
 */
export const isBase64 = (image: unknown): boolean => {
  if (typeof image === 'string') {
    return !!image.match(/data:image/);
  }

  return false;
};
